// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-22d17da6] .el-table .warning-row {\n  color: red !important;\n}\n.font18[data-v-22d17da6] {\n  font-size: 18px;\n}\n.dot[data-v-22d17da6] {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin-right: 5px;\n}\n.red[data-v-22d17da6] {\n  background-color: red;\n}\n.yellow[data-v-22d17da6] {\n  background-color: yellow;\n}\n.green[data-v-22d17da6] {\n  background-color: green;\n}", ""]);
// Exports
module.exports = exports;
